module.exports = __webpack_public_path__ + "img/Deco_fete.2f60076.png";